/** 2-col wrap join classes for a slot in a same-booking group (0-based index). */
export function getTeeTimeSlotWrapJoinClasses(
  index: number,
  total: number,
): Record<string, boolean> {
  if (total < 2) {
    return {};
  }

  const joinsBelow = (i: number) => i + 2 < total;
  const col = index % 2;
  const joinRight = col === 0 && index + 1 < total;
  const joinLeft = col === 1;
  const joinAbove = index >= 2;
  const joinBelow = joinsBelow(index);
  const partnerIndex = col === 0 ? index + 1 : index - 1;
  // Always half-expand when joining below so L-shape top cells stay equal height.
  const expandDown = joinBelow;
  // L-shape top-right: half-extend into the row gap (keep border) to match spine gap.
  const nudgeDown = col === 1 && !joinBelow && partnerIndex >= 0 && joinsBelow(partnerIndex);
  // Always half-join above; full absorb made L top/bottom seams misaligned with nudge.
  const joinAboveHalf = joinAbove;

  const isLast = index === total - 1;
  const spine = col === 0 && isLast && total % 2 === 1;

  return {
    "tee-time-slot--wrap-join-right": joinRight,
    "tee-time-slot--wrap-join-left": joinLeft,
    "tee-time-slot--wrap-expand-down": expandDown,
    "tee-time-slot--wrap-nudge-down": nudgeDown,
    "tee-time-slot--wrap-join-above": joinAboveHalf,
    "tee-time-slot--wrap-spine": spine,
    "tee-time-slot--wrap-radius-tl": col === 0 && !joinAbove,
    "tee-time-slot--wrap-radius-tr": col === 1 && !joinAbove,
    "tee-time-slot--wrap-radius-bl": col === 0 && !joinBelow,
    "tee-time-slot--wrap-radius-br": (col === 1 && !joinBelow) || spine,
  };
}
